//@flow
import React from 'react';
import { Route } from 'react-router';
import { noMatchHandler, onChangeHook } from './routeUtils';
import PageWrapper from '../Shell/components/PageWrapper.react';
import OfficeApp2 from '../Office/components/OfficeApp2.react';
import OfficeCatalog from '../Office/components/OfficeCatalogApp.react';
import OfficeThankYou from '../Office/components/OfficeThankYou.react';
import OfficeReferApp from '../Office/components/OfficeReferApp.react';
import OfficeReferThankYou from '../Office/components/OfficeReferThankYou.react';
import CategoryApp from '../Category/components/CategoryApp.react';

export default (
  <Route component={PageWrapper} onChange={onChangeHook}>

    <Route name="office" component={OfficeApp2} path="/office" />
    <Route name="officecatalog" component={OfficeCatalog} path="/office/catalog" />
    <Route name="officecatalogcategory" component={CategoryApp} path="/office/catalog/products/:urlKey" />
    <Route name="officecatalogstock" component={OfficeCatalog} path="/office/catalog/stock" />
    <Route name="officethanks" component={OfficeThankYou} path="/office/thanks" />
    <Route name="officerefer" component={OfficeReferApp} path="/office/refer" />
    <Route name="officereferthanks" component={OfficeReferThankYou} path="/office/refer/thanks" />

    <Route name="noMatch" onEnter={noMatchHandler} path="*" />
  </Route>
);
